export default "__VITE_PUBLIC_ASSET__731a4c09__"